var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalNoTrainee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_838_5968",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_838_5968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 28V25.2C9 24.6333 9.14583 24.1125 9.4375 23.6375C9.72917 23.1625 10.1167 22.8 10.6 22.55C11.6333 22.0333 12.6833 21.6458 13.75 21.3875C14.8167 21.1292 15.9 21 17 21C18.1 21 19.1833 21.1292 20.25 21.3875C21.3167 21.6458 22.3667 22.0333 23.4 22.55C23.8833 22.8 24.2708 23.1625 24.5625 23.6375C24.8542 24.1125 25 24.6333 25 25.2V28H9ZM27 28V25C27 24.2667 26.7958 23.5625 26.3875 22.8875C25.9792 22.2125 25.4 21.6333 24.65 21.15C25.5 21.25 26.3 21.4208 27.05 21.6625C27.8 21.9042 28.5 22.2 29.15 22.55C29.75 22.8833 30.2083 23.2542 30.525 23.6625C30.8417 24.0708 31 24.5167 31 25V28H27ZM17 20C15.9 20 14.9583 19.6083 14.175 18.825C13.3917 18.0417 13 17.1 13 16C13 14.9 13.3917 13.9583 14.175 13.175C14.9583 12.3917 15.9 12 17 12C18.1 12 19.0417 12.3917 19.825 13.175C20.6083 13.9583 21 14.9 21 16C21 17.1 20.6083 18.0417 19.825 18.825C19.0417 19.6083 18.1 20 17 20ZM27 16C27 17.1 26.6083 18.0417 25.825 18.825C25.0417 19.6083 24.1 20 23 20C22.8167 20 22.5833 19.9792 22.3 19.9375C22.0167 19.8958 21.7833 19.85 21.6 19.8C22.05 19.2667 22.3958 18.675 22.6375 18.025C22.8792 17.375 23 16.7 23 16C23 15.3 22.8792 14.625 22.6375 13.975C22.3958 13.325 22.05 12.7333 21.6 12.2C21.8333 12.1167 22.0667 12.0625 22.3 12.0375C22.5333 12.0125 22.7667 12 23 12C24.1 12 25.0417 12.3917 25.825 13.175C26.6083 13.9583 27 14.9 27 16ZM11 26H23V25.2C23 25.0167 22.9542 24.85 22.8625 24.7C22.7708 24.55 22.65 24.4333 22.5 24.35C21.6 23.9 20.6917 23.5625 19.775 23.3375C18.8583 23.1125 17.9333 23 17 23C16.0667 23 15.1417 23.1125 14.225 23.3375C13.3083 23.5625 12.4 23.9 11.5 24.35C11.35 24.4333 11.2292 24.55 11.1375 24.7C11.0458 24.85 11 25.0167 11 25.2V26ZM17 18C17.55 18 18.0208 17.8042 18.4125 17.4125C18.8042 17.0208 19 16.55 19 16C19 15.45 18.8042 14.9792 18.4125 14.5875C18.0208 14.1958 17.55 14 17 14C16.45 14 15.9792 14.1958 15.5875 14.5875C15.1958 14.9792 15 15.45 15 16C15 16.55 15.1958 17.0208 15.5875 17.4125C15.9792 17.8042 16.45 18 17 18Z",
    fill: "#1853A2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalNoTrainee);
export default __webpack_public_path__ + "static/media/total_no_trainee.8f5e0f64ae4196791a23f1869acc87a4.svg";
export { ForwardRef as ReactComponent };